module.exports = __webpack_public_path__ + "static/media/outline-icons.82f60bd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/outline-icons.svg
// module id = ./src/styling/theme/assets/fonts/outline-icons.svg
// module chunks = 0